import z from "myzod";
import { PlanDiscriminator } from "../../../../utils/discriminator.utils";

/** Backend uses discriminator "update" or "create" to determine if an entity needs to be updated or created- */
export const discriminatorSchema = z.enum(PlanDiscriminator).or(z.undefined());
